import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentType, ImmigrationApi, ImmigrationProfile, ImmAdditionalDocRequests, ImmigrationDocumentType } from '../../core/api.gen';
import { ToastService } from '../../core/toast.service';


@Component({
  selector: 'eos-additional-doc-request',
  templateUrl: './additional-doc-request.component.html',
  styles: []
})
export class AdditionalDocRequestComponent implements OnInit {

  @Input() profile: ImmigrationProfile;
  @Input() visaType: string;
  @Input() countryType: string;
  documentList: ImmigrationDocumentType[] = [];
  @Input() public submit: (profile, requestList, requestorEmail) => void;
  distinctDocTypes: DocumentType[];
  fileDetails: ImmAdditionalDocRequests;
  selectedDocName: ImmigrationDocumentType | any = null;
  AddedDocs: ImmigrationDocumentType[] = [];
  requestList: ImmAdditionalDocRequests[] = [];
  requestedDocs: ImmAdditionalDocRequests[] = []
  isDocumentAdded = false;
  requestorEmail = 'requestor';
  constructor(public modal: NgbActiveModal, private immigrationApi: ImmigrationApi, private toast: ToastService) {
    this.fileDetails = new ImmAdditionalDocRequests();
    this.fileDetails.docTypeId = null;
    this.fileDetails.docNameId = null;
    this.fileDetails.isMandatory = true;
    this.fileDetails.comment = "";
    this.fileDetails.dependentId = null;
    this.selectedDocName = null;
  }

  ngOnInit() {
    this.getrequestorEmail();
    this.getDocumentTypes();
    this.getAlreadyRequestedlist();
  }

  get getdistinctDocTypes(): DocumentType[] {
    this.distinctDocTypes = [];
    if (this.documentList && this.documentList.length > 0) {
      this.distinctDocTypes = this.documentList.filter(
        (docType, i, arr) => arr.findIndex(t => t.docTypeId === docType.docTypeId) === i);
    }
    return this.distinctDocTypes;
  }

  getDocumentTypes() {
    this.immigrationApi.getEligibleDocuments(this.visaType, this.countryType, false, this.profile)
      .subscribe(resp => {
        this.documentList = resp;
      });
  }
  replaceGPNwithCode(docName: string) {
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", "CC+GUI") : `${"CC+GUI"}_${docName}`
    return docN;
  }
  get documentTypes() {
    if (!this.documentList.length) { return [] }
    return this.documentList.filter(doc => doc.docTypeId === +this.fileDetails.docTypeId);
  }

  setCMDocTypes() {
    this.fileDetails.docNameId = null;
    const filteredVals = this.documentList.filter(t => t.docTypeId === this.fileDetails.docTypeId);
    if (filteredVals.length === 1) {
      this.fileDetails.docNameId = filteredVals[0].docNameId;
      this.setDependent();
    }
  }
  setDependent() {    
    this.fileDetails.dependentId = null;
    this.fileDetails.docNameId = this.selectedDocName.docNameId;
    this.fileDetails.dependentId = this.selectedDocName.dependentId;
    }
  deleteDocs(item: ImmigrationDocumentType) {
    this.AddedDocs.forEach((value, index) => {
      if (value.docNameId === item.docNameId && value.dependentId === item.dependentId)
        this.AddedDocs.splice(index, 1);
    });
    this.requestList.forEach((value, index) => {
      if (value.docNameId === item.docNameId && value.dependentId === item.dependentId)
        this.requestList.splice(index, 1);
    });
  }
  addDocs(f: NgForm) {
    if (f.invalid) {
      return;
    }
    this.isDocumentAdded = false;
    if (!(this.AddedDocs.filter(res => res.docNameId == this.fileDetails.docNameId && res.dependentId === this.fileDetails.dependentId).length > 0) && this.fileDetails.docNameId != null) {
      var res = this.documentList.find(t => t.docNameId === this.fileDetails.docNameId && t.dependentId === this.fileDetails.dependentId);
      this.AddedDocs.push(res);
      this.fileDetails.docTypeDisplayText = res.docTypeDisplayText;
      this.fileDetails.dependentId = res.dependentId;
      this.requestList.push(this.fileDetails);
      this.isDocumentAdded = true;
      this.clearSelect();
    } else {
      this.toast.warning('Document already requested');
      return;
    }
  }

  clearSelect() {
    this.fileDetails = new ImmAdditionalDocRequests();
    this.fileDetails.docTypeId = null;
    this.fileDetails.docNameId = null;
    this.fileDetails.comment = "";
    this.fileDetails.isMandatory = true;
    this.fileDetails.dependentId = null;
    this.selectedDocName = null;
  }

  requestDocuments() {
    this.modal.close();
    this.submit(this.profile, this.requestList, this.requestorEmail);

  }

  getAlreadyRequestedlist() {
    this.immigrationApi.getRequestedImmDocuments(this.profile.id)
      .subscribe(resp => {
        this.requestedDocs = resp;
      });
  }

  getrequestorEmail() {
    this.immigrationApi.getEmailOfRequestor(this.profile)
      .subscribe(resp => {
        this.requestorEmail = resp;
      });
  }
  isDocuploaded(item, type) {
    const newlyRequestedIds = this.AddedDocs;//.map(doc => doc.docNameId);
    const alreadyRequestedIds = this.requestedDocs;//.map(doc => doc.docNameId)
    const uploadedFileIds = [...newlyRequestedIds, ...alreadyRequestedIds];
    const allDocNameIds = this.documentList.filter(doc => doc.docTypeId == item.docTypeId);//.map(doc => doc.docNameId);
    const allDepIds = this.documentList.filter(doc => doc.docTypeId == item.docTypeId).map(doc => doc.dependentId);

    let res;
    if (type == 'docType') {
      if (allDocNameIds.length > 0) {

        if (allDepIds.length > 0 && allDepIds[0]) {
          res = uploadedFileIds.filter(x => x.docTypeId == item.docTypeId && x.docNameId === item.docNameId).length == allDepIds.length;
        }
        else {
          res = allDocNameIds.map(x => x.docNameId).every(id => uploadedFileIds.map(x => x.docNameId).includes(id))
        }
        // res = allDocNameIds.every(x=> x.dependentId === uploadedFileIds.filter(doc=>doc.docTypeId == x.docTypeId && doc.dependentId == x.dependentId).map(z=>z.dependentId))
      }
    }

    if (type == 'docNameId') {
      res = uploadedFileIds.filter(x => x.docNameId == item.docNameId && x.dependentId === item.dependentId).length > 0
    }

    if (item.docNameId == 6083) {
      res = false;
    }
    return res;
  }
}
